import actions from "@/store/modules/conversations/actions";
import { mutations, state } from "@/store/modules/conversations/mutations";

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
